/* @flow */
import { formatDollars } from '../../utils';

export const getCurrentUser = (state: Object) => {
  return state.currentUser;
};

export const getCurrentUserAccessToken = (state: Object) => {
  return (state.currentUser || {}).accessToken;
};

export const getCurrentUserId = (state: Object) => {
  return (state.currentUser || {}).userId;
};

export const getCredits = (state: Object) => {
  return (state.entities || {}).credits;
};

export const getDisplayCredits = (state: Object) => {
  const credits = getCredits(state);
  const total = credits ? credits.amount : 0;

  return {
    displayTotal: formatDollars(total),
  };
};



// WEBPACK FOOTER //
// ./src/redux/current-user/selectors.js